import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { Outlet, useLocation } from 'react-router-dom';

import { normalizeUrl } from '@utils/url_validations';

// MetaTagLayout is a Route component that sets common meta tags for a client
// side application. It is only concerned with dynamic tags that are page
// independent. Static tags that are common across the app are served up on the
// initial page load. Tags that are specific to a page are managed by the
// componenet the page route mounts.
//
// TODO: Should the base tag be set here? It is currently set to the
//       rel_canonical value which may actually be incorrect. This could be
//       statically set at the base layout erb file.
const MetaTagLayout = () => {
  const location = useLocation();
  const [canonicalUrl, setCanonicalUrl] = useState(normalizeUrl(window.location.href));
  const [baseUrl, setBaseUrl] = useState(normalizeUrl(window.location.href));

  useEffect(() => {
    setCanonicalUrl(normalizeUrl(window.location.href));
    setBaseUrl(normalizeUrl(window.location.href));
  }, [location]);

  return (
    <>
      <Helmet>
        <base href={baseUrl} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:url" content={canonicalUrl} />
      </Helmet>
      <Outlet />
    </>
  );
};

export default MetaTagLayout;
